
export var frases = [
	{autor:'', texto:''},

	// {autor:'Leonardo da Vinci', texto:'Estudiar sin deseo arruina la memoria, y no retiene nada de lo que absorbe'},
	// {autor:'Leonardo da Vinci', texto:'Cuando no puedes hacer lo que quieres, quieres lo que puedes hacer'},

	// {autor:'Morgan Freeman', texto:'Nosotros los humanos estamos más preocupados por tener que por ser'},
	// {autor:'Morgan Freeman', texto:'El perdón libera el alma, elimina el miedo'},

	// {autor:'Isaac Newton', texto:'Lo que sabemos es una gota, lo que no sabemos es un océano'},
	// {autor:'Isaac Newton', texto:'Si he logrado ver más lejos, ha sido porque he subido a hombros de gigantes'},

	// {autor:'Pitágoras', texto:'Si sufres injusticias, consuélate, porque la verdadera desgracia es cometerlas'},
	// {autor:'Pitágoras', texto:'No digas pocas cosas en muchas palabras, sino muchas cosas en pocas palabras'},

	// {autor:'Pablo Picasso', texto:'Siempre estoy haciendo lo que no puedo hacer, para poder aprender a hacerlo'},
	// {autor:'Pablo Picasso', texto:'Todo acto de creación es ante todo un acto de destrucción'},
];

export var palabras = [
	"ova",
	"objecto",
	"virtual",
	"aprendizaje",
	"software",
	"educativo",
	"diseño",
	"practicas",
	"tutoriales",
	"simulaciones",
	"evaluación",
	"retroalimentacion",
	"aprendiz",
	"sistema",
	"simuladores",
	"constructores",
	"constructivismo",
	"lms",
	"cms",
	"lom",
	"ims",
	"scorm",
	"exelearning",
	"reload",
	"html",
	"xhtml",
	"xml",
	"windows",
	"linux",
	"mac",
	"github",
	"gitlab",
	"navegación",
	"sonidos",
	"videos",
	"python",
	"java",
	"php",
	"javascript",
	"iexplorer",
	"firefox",
	"chrome",
	"opera",
	"safari",
	"metadata",
	"metadatos",
	"database",
	"moodle",
	"chamilo",
	"canvas",
	"sakai",
	"blackboard",
	"saba",
	"neo",
	"educativa",
	"firstclass",
	"drupal",
	"wordpress",
	"joomla",
	"timeline",
	"paquetes",
	"courselab",
	"medeovas",
	"metodología",
	"navegador",
	"plugin",
	"flash",
];
